import { useState } from "react";
import { LoadingOutlined, SearchOutlined } from "@ant-design/icons";
import { useFetchCompaniesQuery } from "@services";
import { setSelectedCompanyInStorage } from "@/services/global-storage";
import { ICompany } from "@/types";

import { useTypedSelector } from "@/hooks";
import CompanySelectCarousel from "@components/caurosel";
import CompanyList from "@/components/List/company-list";
import { BiChevronRight } from "react-icons/bi";
import "./apps.less";

export interface CompanyListType {
  name: string;
  desc: string;
  continents: string;
  icon: string;
}

const Apps = () => {
  const [
    page,
    // setPage
  ] = useState(1);
  const selectedApp = useTypedSelector(state => state.selected_app);
  const [searchString, setSearchString] = useState<string>("");
  const [selectedCompany, setselectedCompany] = useState<string | null>(null);

  const { data: companiesData, isLoading: isFetching } =
    useFetchCompaniesQuery(page);
  const { data } = companiesData || {};
  const onPressNext = () => {
    window.open(selectedApp.applicationLink, "_self");
    // window.open("http://localhost:3000", "_self");
  };

  let handleCompanySelect = (companyId: any) => {
    const findCompany = data?.find((item: any) => item.id == companyId);
    if (findCompany) {
      setselectedCompany(findCompany);
      setSelectedCompanyInStorage(findCompany);
      onPressNext();
    }
  };
  return (
    <div className="ApplicationSelector  w-full px-12">
      {isFetching ? (
        <div
          style={{ height: "650px" }}
          className="flex justify-center items-center "
        >
          <LoadingOutlined className="spinner " style={{ fontSize: "80px" }} />
        </div>
      ) : (
        <main className="relative min-h-screen bg-[#FAFAFA] px-8 py-8 mt-10">
          <div className="max-w-6xl mx-auto">
            {/* Header */}
            <div className="text-center mb-10">
              <h1 className="text-4xl font-semibold text-[#4A4A4A] mb-3">
                Select The Company
              </h1>

              <p className="text-sm font-medium text-[#6F6F6F]">
                Choose A Company To Access And Manage Its Operations
              </p>
            </div>

            {/* Company Count */}
            <div className="flex justify-end mb-3">
              <span className="text-xs text-[#6F6F6F]">
                {data?.length || 0} of {data?.length || 0} companies
              </span>
            </div>

            {/* Company Grid */}
            <div className="max-w-6xl">
              <CompanyList
                companiesList={data && data}
                onSelectCompany={setselectedCompany}
                selectedCompany={selectedCompany}
              />
            </div>

            {/* Continue Button */}
            {selectedCompany && (
              <div className="mt-10 flex justify-center">
                <button
                  onClick={() => handleCompanySelect(selectedCompany)}
                  className="
            w-80
            h-12
            rounded
            text-white
            font-medium
            transition-all
            duration-200
            hover:opacity-90
          "
                  style={{
                    backgroundColor: "#F7935A",
                  }}
                >
                  {data?.find((item: any) => item?.id == selectedCompany)?.name}
                </button>
              </div>
            )}

            {/* Footer Logo */}
            {/* <div className="absolute bottom-6 right-8">
      <img
        src={Logo}
        alt="Compensation Core"
        className="h-6 object-contain"
      />
    </div> */}
          </div>
        </main>
      )}
    </div>
  );
};

export default Apps;
